/** Review / Mapping Check discipline hats — shared across Review panels. */
export const DISCIPLINE_HATS = [
  { id: 'architect', label: 'Architect' },
  { id: 'structural_engineer', label: 'Structural Engineer' },
  { id: 'civil_engineer', label: 'Civil Engineer' },
  { id: 'mechanical_engineer', label: 'Mechanical Engineer' },
  { id: 'electrical_engineer', label: 'Electrical Engineer' },
  { id: 'plumbing_engineer', label: 'Plumbing Engineer' },
];

export function hatLabel(hatId) {
  return DISCIPLINE_HATS.find((h) => h.id === hatId)?.label || hatId || '—';
}
